import { GAME_API } from "@/constants/constants"


const customFetch = async (url: string, options?: RequestInit) => {
  while (true) {
    try {
      const response = await fetch(url, options)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${await response.json()}`)
      }
      return response.json();
    } catch (error) {
      console.error('Error fetching', url, error)
      await new Promise((resolve) => setTimeout(resolve, 500))
    }
  }

};

export const getCoinflipGameResult = (gameId: string, gameStep: string, randomRound: string) => {
  return customFetch(`${GAME_API}/games/coinflip/${gameId}/${gameStep}/${randomRound}`).then((res) => res.result)
}

export const getRunesGameResult = (gameId: string, randomRound: string) => {
  return customFetch(`${GAME_API}/games/runes/${gameId}/${randomRound}`).then((res) => res.result)
}

export const getPlinkoGameResult = ({ gameId, randomRound, balls, rows }: { gameId: string; randomRound: string; balls: number; rows: number }) => {
  return customFetch(`${GAME_API}/games/plinko/${gameId}/${randomRound}?balls=${balls}&rows=${rows}`).then((res) => res.result)
}